import { render, staticRenderFns } from "./AllGames.vue?vue&type=template&id=347c60d1&scoped=true&"
import script from "./AllGames.vue?vue&type=script&lang=js&"
export * from "./AllGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c60d1",
  null
  
)

export default component.exports